import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import muiThemeable from 'material-ui/styles/muiThemeable';

const CategoryBanners = ({ children }) => (
  <div >
    {children}
  </div>
)

CategoryBanners.propTypes = {};
CategoryBanners.defaultProps = {};

export default compose(withRouter, muiThemeable())(CategoryBanners);




// WEBPACK FOOTER //
// ./src/pages/Banners/children/CategoryBanners/index.js